/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import API from '../../../API/api';

export const PostcodeAutocomplete = ({
    name,
    minLength,
    value,
    onChange,
    native,
    position,
    selectSuggestion,
    children,
    ...props }) => {

    const [result, setResult] = useState([]);
    const [isLoading, setIsLoading] = useState();
    const [isData, setIsData] = useState(false);
    const [isComponentVisible, setIsComponentVisible] = useState(false);
    const ref = useRef(null);
    const timeout = useRef();

    const handleDebounceSearch = (e) => {
        let val = e;
        if (Object.prototype.hasOwnProperty.call(e, 'target')) {
            val = e.target.value;
            onChange(e);
        } else {
            onChange(val, name);
        }

        // Clear the previous timeout.
        clearTimeout(timeout.current);

        // Clear any previous selected suggestion
        selectSuggestion && selectSuggestion(null);


        // If there is no search term, do not make API call
        if (!val.trim() || val.length < minLength) {
            setResult([]);
            return;
        }
        timeout.current = setTimeout(async () => {
            try {
                const queryResult = await API.FETCH_GET(`/api/v2/addressing/search/?text=${val}`)
                const response = await queryResult.json();
                setResult(response);
                setIsData(true);
            } catch (ex) {
                setResult([]);
                console.log(ex);
            } finally {
                setIsLoading(false);
                setIsComponentVisible(true);
            }

        }, 300);
    }

    const setSuggestion = (e) => {
        if (native) {
            const event = {
                target: {
                    value: e.target.innerText,
                }
            }
            onChange(event);
        } else {
            onChange(e.target.innerText, name)
        }
        selectSuggestion && selectSuggestion(result[e.target.dataset.index]);
        setResult([]);
        setIsData(false);
        setIsComponentVisible(false);
    }

    const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
            setIsComponentVisible(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

    const el = React.cloneElement(children, {
        minLength,
        onChange: handleDebounceSearch,
        ...props,
    })

    return (
        <div>
            {el}
            {
                value && value.length >= minLength && isComponentVisible && <div
                    className={`autocomplete-suggestions-container ${native ? '' : 'custom'}`}
                    ref={ref}
                    style={{ [position]: '100%' }}>
                    <ul className="suggestions-results">
                        {result.length > 0 && result?.map((x, i) => (
                            <li className="suggestions" key={Math.random()} onClick={setSuggestion} data-index={i}>{x.autoSuggestLabel}</li>
                        ))}
                        {
                            result.length === 0 && value && isData && <li className="suggestions" key='not-found'>No data found</li>
                        }
                    </ul>
                </div>
            }
        </div>)

}

PostcodeAutocomplete.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    position: PropTypes.string,
    native: PropTypes.bool,
    minLength: PropTypes.number,
    selectSuggestion: PropTypes.func
}
PostcodeAutocomplete.defaultProps = {
    minLength: 3,
    native: false,
    position: 'top',
    selectSuggestion: () => { }
};